import { type DocumentNode, type OperationDefinitionNode, Kind } from "graphql";

const getOperationName = (query: DocumentNode) => {
  const definition = query.definitions.find(defn => {
    return defn?.kind === Kind.OPERATION_DEFINITION && !!defn?.name?.value;
  }) as OperationDefinitionNode;

  return definition?.name?.value;
};

export { getOperationName };
